
<mat-dialog-content class="sold-to-dialog">
    <div class="sold-to-header"></div>
    <button  class="close-btn data-protection-close" mat-icon-button aria-label="close dialog" mat-dialog-close>
        <mat-icon><div class="close"><img src="/icons/close.svg" alt="" width="20" height="20" /></div></mat-icon>
    </button>
    <div class="disclaimer-top-content">
        <p>{{'common.default_sold_to_info1'|cxTranslate}}</p>
        <p>{{'common.default_sold_to_info2'|cxTranslate}}</p>
    </div>
 
    </mat-dialog-content>
